import { createEffect, createEvent, createStore, sample } from 'effector';
import { authApi, type AccountUser, type SignInMethod } from '../../shared/api/auth';

/*
 * The account session (M7). Anonymous use is first-class: without an API (e.g. a static host) or
 * without a session the app simply stays anonymous and local-first.
 */

export type Session =
  { status: 'unknown' } | { status: 'anonymous' } | { status: 'signedIn'; user: AccountUser };

export const sessionCheckRequested = createEvent();
export const signOutRequested = createEvent();
/** The session ended (after signing out elsewhere in the app, e.g. the sync's sign-out). */
export const signedOut = createEvent();

export const checkSessionFx = createEffect(() => authApi.me());
export const loadMethodsFx = createEffect(() => authApi.methods());
export const logoutFx = createEffect(() => authApi.logout());

export const $session = createStore<Session>({ status: 'unknown' })
  .on(checkSessionFx.doneData, (_, user) =>
    user ? { status: 'signedIn', user } : { status: 'anonymous' },
  )
  .on(checkSessionFx.fail, () => ({ status: 'anonymous' }))
  .on([logoutFx.done, signedOut], () => ({ status: 'anonymous' }));

export const $user = $session.map((s) => (s.status === 'signedIn' ? s.user : null));

/** Sign-in methods the API offers ([] without an API). */
export const $signInMethods = createStore<SignInMethod[] | null>(null)
  .on(loadMethodsFx.doneData, (_, methods) => methods)
  .on(loadMethodsFx.fail, () => []);

sample({ clock: sessionCheckRequested, target: checkSessionFx });
